export default __webpack_public_path__ + "3475d336584d827e27b149d9b8fc22d3.riv";